import type { ReactNode } from 'react'
import { Eye } from 'lucide-react'

interface Props {
  title: string
  children: ReactNode
}

export function LearnerMirrorSection({ title, children }: Props) {
  return (
    <section aria-label={title} className="rounded-lg border border-sky-100 bg-sky-50/60 p-3">
      <header className="flex items-center gap-1.5 mb-2 text-xs font-semibold text-sky-800">
        <Eye size={14} aria-hidden="true" />
        <span>{title}</span>
      </header>
      <div className="text-sm">{children}</div>
    </section>
  )
}
